var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentSuccessIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-131.881 -271.881)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_49",
    "data-name": "Rectangle 49",
    width: 108,
    height: 108,
    rx: 32,
    transform: "translate(131.881 271.881)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Evento_Icons",
    "data-name": "Evento Icons",
    transform: "translate(154.686 294.686)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0,0H61.565V61.565H0Z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_62783",
    "data-name": "Group 62783",
    transform: "translate(3.952 4.006)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M5.642,42.45A26.263,26.263,0,0,1,36.19,1.91c-1.3,1.279-2.5,2.518-3.758,3.666a1.526,1.526,0,0,1-1.178.232,21,21,0,1,0,15.6,24.445c.262-1.269.333-2.569.5-3.938h5.027c1.639,7.493-5.825,19.339-14.9,23.659A26.1,26.1,0,0,1,5.642,42.45Zm6.5-17.556c1.048-1.027,2.246-2.216,3.444-3.4,2.52,2.538,5.17,5.187,7.8,7.836,7.614-7.6,15.11-15.1,22.561-22.552,1.432,1.441,2.611,2.619,3.746,3.767-8.63,8.642-17.343,17.335-25.946,25.947C19.882,32.63,15.986,28.732,12.137,24.894Z",
    transform: "translate(0.947 0.971)",
    fill: "#31c24e"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentSuccessIcon);
export default __webpack_public_path__ + "static/media/PaymentSuccessIcon.532ddd5cfc1a517a5fea56ff00a0ab91.svg";
export { ForwardRef as ReactComponent };